import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trellisComponents"];
import CustomComponentFallbackTransitional, { resetWarnedTypes } from './CustomComponentFallback.transitional';
import CustomComponentFallbackAlpha from './CustomComponentFallback.alpha';
import { jsx as _jsx } from "react/jsx-runtime";
export { resetWarnedTypes };
const CustomComponentFallback = _ref => {
  let {
      trellisComponents
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (trellisComponents) {
    return /*#__PURE__*/_jsx(CustomComponentFallbackAlpha, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(CustomComponentFallbackTransitional, Object.assign({}, props));
};
export default CustomComponentFallback;